import { ColumnsType } from 'antd/es/table';
import { Edit2 } from 'iconsax-react';
import SectionDesc from '../../../components/atoms/SectionDesc';
import CustomTable from '../../../components/atoms/CustomTable';
import { useTranslation } from 'react-i18next';
import dayjs from 'dayjs';

import { CoinsDeductionData } from '../../../types/coins';

interface CoinsSectionProps {
  data: CoinsDeductionData[];
  isLoading?: boolean;
  onEdit: (item: CoinsDeductionData) => void;
}

export default function CoinsSection({
  data,
  isLoading,
  onEdit,
}: CoinsSectionProps) {
  const { t, i18n } = useTranslation();

  const coinColumns: ColumnsType<CoinsDeductionData> = [
    { title: t('home.service-type'), dataIndex: 'name', key: 'name' },
    {
      title: t('home.user-type'),
      dataIndex: 'profileType',
      key: 'profileType',
      render: (val: string) => {
        if (val === 'BUSINESS_BUYER') return t('home.businessBuyer', 'Buyer');
        if (val === 'BUSINESS_SELLER')
          return t('home.businessSeller', 'Seller');
        return val;
      },
    },
    {
      title: t('home.coins-amount-col'),
      dataIndex: 'coinsNo',
      key: 'coinsNo',
      render: (val) => `${val} ${t('home.coin-unit', 'Coin')}`,
    },
    {
      title: t('home.changed-by'),
      dataIndex: 'editedByName',
      key: 'editedByName',
      render: (val) => val || '-',
    },
    {
      title: t('home.date-applied'),
      dataIndex: 'editedDate',
      key: 'editedDate',
      render: (val) => (val ? dayjs(val).locale(i18n.language).format('DD MMM YYYY') : '-'),
    },
    {
      title: t('home.action'),
      key: 'action',
      render: (_, record) => (
        <div
          className="w-8 h-8 rounded-md bg-blue-50 flex items-center justify-center cursor-pointer transition-colors hover:bg-blue-100"
          onClick={() => onEdit(record)}
        >
          <Edit2 size={16} className="text-blue-500" variant="Bold" />
        </div>
      ),
    },
  ];

  return (
    <div className="bg-white rounded-xl p-6 flex flex-col gap-6 shadow-sm border border-gray-100">
      <div className="flex flex-col gap-1">
        <h3 className="text-[#111928] text-2xl font-bold leading-none">
          {t('home.coins')}
        </h3>
        <SectionDesc text={t('home.coins-service-limits-sub-desc')} />
      </div>
      <CustomTable
        loading={isLoading}
        columns={coinColumns}
        dataSource={data}
        rowKey="id"
        currentPage={0}
        totalElements={data.length}
        onPageChange={() => {}}
        onRowClick={() => {}}
        pagination={false}
        scroll={{ x: 'max-content' }}
      />
    </div>
  );
}
